import { EventEmitter, Injectable } from "@angular/core";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  Event as NgEvent,
} from "@angular/router";
import { Subscription } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class HandleFormDirtyService {
  routes = {
    ilock: null,
    wallReader: null,
    doorManagement: null,
    accessRights: null,
    accessProfile: null,
    persons: null,
    accessCards: null,
    defaultSettings: null,
    cardSettings: null
  };

  lastSubscription = null as Subscription;

  routeClosePermitEmitter = new EventEmitter<string>();

  lastRoute = "";

  constructor(private _router: Router) {}

  initListener() {}

  closeRoute(routeID) {
    this.routeClosePermitEmitter.emit(routeID);
  }
}
